import { Icons } from './Icons'
import { LangFlags } from './LangFlags'
import { openChat, CHAT_LABEL, CHAT_TAGLINE, CHAT_WA_FALLBACK } from '@/lib/chat'

export function HelpBand() {
  return (
    <section className="help-band" data-sezione="aiuto">
      <div className="help-band-inner">
        <div className="help-band-text">
          <span className="kicker">Sempre disponibili ad aiutarti</span>
          <h3>Hai dubbi? Ti rispondiamo noi, nelle lingue disponibili.</h3>
          <p>Facciamo dell'assistenza al cliente il nostro punto di forza. Tecnica, commerciale, amministrativa — risponde una persona, non un bot.</p>
        </div>
        <div className="help-band-actions">
          <a className="contact-channel cc-primary" href={CHAT_WA_FALLBACK} target="_blank" rel="noopener noreferrer" onClick={openChat}>
            <span className="cc-icon"><Icons.chat /></span>
            <div className="cc-text">
              <strong>{CHAT_LABEL}</strong>
              <span>{CHAT_TAGLINE}</span>
            </div>
            <Icons.arrow className="cc-arrow" />
          </a>
          <div className="help-band-row">
            <a className="contact-channel" href="tel:+3905442330899">
              <span className="cc-icon"><Icons.phone /></span>
              <div className="cc-text">
                <strong>0544 2330899</strong>
                <span>Lun–Ven 9:00–18:00 · Sab 9:00–13:00</span>
              </div>
            </a>
            <a className="contact-channel" href="mailto:info@spadhausen.com">
              <span className="cc-icon"><Icons.mail /></span>
              <div className="cc-text">
                <strong>info@spadhausen.com</strong>
                <span>Risposta entro 4 ore</span>
              </div>
            </a>
          </div>
          <div className="contact-channel">
            <span className="cc-icon"><Icons.globe /></span>
            <div className="cc-text"><strong>Lingue disponibili</strong><LangFlags /></div>
          </div>
        </div>
      </div>
    </section>
  )
}
